import { msalInstance } from '../auth/msal'

export const logout = async (isAccountDeleted?: boolean) => {
    sessionStorage.clear()
    localStorage.clear()
    msalInstance.logoutRedirect();
}
